/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/* eslint-disable no-alert */

import { JS_BROWSER_ALERT_SECURITY_HEADER, JS_BROWSER_ALERT_SECURITY_FOOTER } from "constants/constants";
import { getIntl } from "selectors/appSelectors";
import * as stores from "stores";
import { isFullScreenMode } from "selectors/documentSelectors";
import { fullScreenExitReason } from "constants/enums";

const updateWithHeaderAndFooter = ({
  message,
  header = JS_BROWSER_ALERT_SECURITY_HEADER,
  footer = JS_BROWSER_ALERT_SECURITY_FOOTER
}) => {
  header = getIntl(stores).formatMessage({ id: header });
  footer = getIntl(stores).formatMessage({ id: footer });
  const msg = `${header}${message}${footer}`;
  return msg;
};

const setFullScreenExitStatus = () => {
  if (isFullScreenMode(stores)) {
    stores.pageByPageStore.setFullScreenExitReason(fullScreenExitReason.BROWSER_ALERT);
  }
};

export const windowAlert = props => {
  setFullScreenExitStatus();
  const msg = updateWithHeaderAndFooter(props);
  return window.alert(msg);
};

export const windowConfirm = props => {
  setFullScreenExitStatus();
  const msg = updateWithHeaderAndFooter(props);
  return window.confirm(msg);
};

export const windowPrompt = props => {
  setFullScreenExitStatus();
  const msg = updateWithHeaderAndFooter(props);
  return window.prompt(msg, props.defaultValue);
};
